import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */

/* @jsx mdx */

import DefaultLayout from "/home/runner/work/reevesdotnl/reevesdotnl/src/templates/pdf-view.tsx";
export const _frontmatter = {};

const makeShortcode = name => function MDXDefaultShortcode(props) {
  console.warn("Component " + name + " was not imported, exported, or provided by MDXProvider as global scope");
  return <div {...props} />;
};

const PublishDate = makeShortcode("PublishDate");
const layoutProps = {
  _frontmatter
};
const MDXLayout = DefaultLayout;
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">


    <p>{`It is now 50 years since Alan Smith and Tony Hallam published in Nature their
classic paper on  Gondwana reconstruction (Smith & Hallam, 1970). Here is a link
to a video of Alan talking about  this work in 2012
`}<a parentName="p" {...{
        "href": "https://youtu.be/SXzyEzhY23g"
      }}>{`[`}{`link`}{`]`}</a>{`. Smith and Hallam applied the same
contour-fitting algorithm used in  Bullard, Everett and Smith (1965) to fit the
500 fathom (914 m) bathymetric contours for South  America, Africa, Madagascar,
India and Australia to each other and to the 1000 m isobath for  Antarctica. The
result has withstood well the test of time. The figure at the bottom of this
piece  presents the fit resulting from current research (available on this
website) alongside the original  Smith & Hallam (1970) fit.`}</p>
    <p>{`The main difference in the result is that the convex section of the Mozambique
coast of Africa is  now fitted into the concave section of the Antarctic coast
occupied by Sri Lanka in the 1970 fit. A  slightly more northwesterly position
for Madagascar against Africa then allows the remainder of  the assembly of
India, Australia and Antarctica to fit snugly against Africa and Madagascar.
The  modern fit uses offshore satellite gravity anomalies ('gravity
margins') with persuasively conjugate  detail in place of bathymetric
contours. The Smith & Hallam (1970) position for Sri Lanka - which  they
explain as arbitrary - survived into the 1988 geological map of Gondwana (de
Wit et al.,  1988) and is still reproduced from time to time.`}</p>
    <p>{`The arcuate Antarctic Peninsula and the somewhat similar southernmost section of
South America  have long posed a problem for a satisfactory reassembly. In the
second part of the figure we  show our recent solution (highlighted in yellow)
which brings Patagonia back along the Agulhas  fault with the 'sole' of the
Malvinas Plateau originally in contact with the Coats Land coast of  Antarctica.
This 1500 km-long line of contact behaved, we believe, as a dextral strike-slip
feature  in the earliest disruption of East and West Gondwana, conforming to the
Euler pole for the first  movements of the first two pieces Gondwana broke into
in Jurassic times. This model is  demonstrated in the animation on the
`}<a parentName="p" {...{
        "href": "/reevesdotnl/gondwana"
      }}>{`'Gondwana'`}</a>{` page. Small fragments such as the Maurice Ewing Bank,
South Georgia and the South Orkney Islands may all have their origins in this
shear  zone which developed eventually into a broad rift before the onset of
ocean growth in the Weddell Sea.  `}</p>
    <PublishDate updated="2020-07-31" mdxType="PublishDate" />
    <p>{`References`}</p>
    <p>{`Bullard, E.C., Everett, J.E. & Smith, A.G., 1965. Phil Trans Roy Soc, A, 258, 41.`}</p>
    <p>{`Smith, A.G. & Hallam, A.,1970. Nature, 225, 139.`}</p>
    <p>{`de Wit et al, 1988. Geological map of sectors of Gondwana, AAPG.`}</p>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      